import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Layout from "@components/layout/Layout";
import DeclarationWorkflow from "@components/form/declaration/DeclarationWorkflow";
import { useGetLevel1Resource } from "@hooks/query/useGetLevel1Resource";

const CreateDeclaration = () => {
  const { t } = useTranslation();
  const { id: level1ResourceId = "" } = useParams();

  const { data: level1Resource = {} } = useGetLevel1Resource(level1ResourceId, {
    enabled: Boolean(level1ResourceId),
  });

  return (
    <Layout
      permissions={["CreateDeclarations"]}
      breadcrumb={[
        {
          label: t("dashboard.dashboard"),
          href: "/polestar",
        },
        {
          label: level1Resource?.name,
          href: `/polestar/level1wrs/${level1ResourceId}`,
        },
        {
          label: t("level1wrs.extraction_points"),
          href: `/polestar/level1wrs/${level1ResourceId}#5`,
        },
        {
          label: t("declaration.entering_read"),
        },
      ]}
      title={t("declaration.entering_read")}
      accountingPeriodLevel1ResourceId={level1ResourceId}
    >
      <DeclarationWorkflow />
    </Layout>
  );
};

export default CreateDeclaration;
